var _circle, _mask, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFemaleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 31,
    transform: "matrix(-1 0 0 1 31 31)",
    fill: "#E3E5EF"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 62,
    height: 62
  }, /*#__PURE__*/React.createElement("circle", {
    r: 31,
    transform: "matrix(-1 0 0 1 31 31)",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.9663 42.1967C34.8024 47.8307 37.2615 57.0768 38.3365 65.8246C39.734 77.1934 40.3226 86.6647 41.7309 91.4083C42.822 93.4462 47.7671 92.6035 48.5492 90.3483C48.4041 81.0095 48.3987 73.796 48.1649 66.1691C47.7886 61.2453 46.7647 51.252 45.6144 46.6038C44.0825 40.3841 42.6742 35.0045 38.3607 35.8127C36.4848 36.1652 35.0819 38.2349 34.9663 42.1967Z",
    fill: "#99AAE0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.9663 42.1969C34.8024 47.8309 37.2615 57.077 38.3365 65.8248C39.734 77.1935 40.3226 86.6648 41.7309 91.4084C42.521 92.8845 45.3295 92.8501 47.1194 91.8616C46.7754 83.2993 46.3374 75.0072 46.4744 66.4025C45.2973 56.2607 44.5125 40.9487 39.2772 35.736C38.9896 35.7281 38.6832 35.7519 38.3607 35.8129C36.4848 36.1653 35.0819 38.235 34.9663 42.1969Z",
    fill: "#0073BA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2639 71.9982C22.5617 76.5007 23.3304 81.557 22.5375 83.9924C21.6641 86.6743 13.3757 92.6899 14.8458 104.435C16.3454 108.418 21.3577 110.554 27.1306 109.547C28.9286 109.232 46.137 102.755 48.7197 97.1738C48.5504 93.1775 48.1096 87.8005 47.7683 86.017C46.8438 81.1568 45.5699 79.4952 44.9491 76.4212C44.1643 72.5547 45.801 69.2978 45.371 64.8245C45.2581 63.6267 45.1399 62.4156 45.0163 61.2072C44.6024 57.1182 44.1455 53.0397 43.6752 49.4675C43.0705 44.859 42.5115 40.9316 41.9068 39.0792C41.7428 38.4141 41.3854 37.7887 40.9984 37.2427C39.7621 35.5017 37.5422 34.6192 33.6748 36.2172C28.3158 38.4326 20.3015 41.8141 15.7891 46.5418C13.7224 47.782 12.212 49.2607 12.0265 51.9347C11.6073 57.9423 17.6032 66.7962 20.2639 71.9982Z",
    fill: "#99AAE0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.3012 71.9763C21.043 73.4312 21.4945 74.9232 21.9245 76.3701C23.2065 80.7188 23.1366 83.2046 20.5969 86.6152C18.0464 90.0364 13.6872 95.5804 14.7971 104.437C15.8479 107.23 18.6806 109.114 22.2416 109.642C21.2687 101.339 24.4266 95.0822 26.4369 89.4004C28.1973 84.4289 27.4179 81.286 27.1975 77.1386C27.1276 75.8056 27.5146 74.5363 28.7133 73.243C29.3583 72.5434 31.1321 72.0214 32.6425 71.4649C37.421 69.7026 38.4987 67.0234 40.9417 65.8547C42.487 65.1153 43.9141 64.4634 45.3009 63.8353C45.3009 58.893 43.089 53.9453 41.5114 49.3077L22.0858 56.6775C21.1881 52.2546 19.3418 49.0109 16.4741 46.1489C14.0822 47.4739 12.2708 48.9659 12.0666 51.9127C11.6473 57.9204 17.6432 66.7743 20.3012 71.9763Z",
    fill: "#99AAE0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.6421 68.0779C30.7098 69.122 26.6032 69.7766 23.6899 66.3527C23.1577 64.8077 22.7546 63.321 22.6847 61.7973C22.4186 55.9592 21.5989 52.8215 18.2368 48.123C20.3412 46.9887 22.4858 45.783 23.6522 44.5401L36.9583 37.3876L41.1966 38.4926C43.4273 42.4831 44.6028 44.5401 46.0664 48.2926C47.0464 50.805 48.1923 53.0176 47.5553 55.6995C46.5771 59.8362 42.5431 61.1957 39.1944 62.8758C37.3507 63.8007 35.5527 66.5091 32.6421 68.0779Z",
    fill: "#99AAE0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3015 53.5488C19.826 54.2802 16.3026 62.4742 14.9266 60.5741C11.8063 56.2704 10.175 50.8988 14.7143 46.9555C19.5707 42.7392 27.4533 38.7854 33.7153 36.1962C36.6259 34.9931 38.604 35.1972 39.9343 36.1141L37.5988 37.0416L23.817 43.1765C21.7557 44.8619 20.3017 46.6269 18.2377 48.3627C19.5599 50.2071 20.5328 51.3413 21.3015 53.5488Z",
    fill: "#99AAE0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.0168 34.5259C40.8163 36.9719 40.9642 46.7082 40.862 57.5787C39.3033 51.3829 37.8627 44.8982 32.6811 42.5688C29.8296 41.2862 33.4578 36.4525 34.0168 34.5259Z",
    fill: "#361D07"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.8621 57.5783C39.3033 51.3825 37.8627 44.8978 32.6811 42.5684C30.8294 41.7336 31.7136 39.4016 32.7134 37.3398C40.0047 43.1302 40.6067 55.885 40.8621 57.5783Z",
    fill: "#241304"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.8595 41.0167C23.2414 46.3406 33.7255 48.2672 35.4079 44.8619C35.5907 41.1651 35.8299 38.4991 37.9369 34.4763L27.9204 30.5781L25.3807 29.4863C26.6788 34.7122 25.679 36.5301 23.8595 41.0167Z",
    fill: "#E8A476"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.8572 40.9143C23.8464 40.9646 23.8384 41.0521 23.8438 41.0945C28.4825 36.1574 32.9599 37.9091 36.5075 36.7404C36.6177 36.4913 36.8918 35.6778 36.9913 35.5797C37.303 34.7052 37.4347 34.8483 37.8513 33.722L27.8348 29.8238L25.2977 28.7346C26.5931 33.9579 25.6767 36.4304 23.8572 40.9143Z",
    fill: "#DB9669"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.1022 26.7868L33.3049 25.1411V17.4454L35.5007 11.4324C41.9535 13.6584 41.5208 25.475 38.1022 26.7868Z",
    fill: "#241304"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.6861 36.7943C20.1522 35.0823 16.9513 27.5244 17.0159 22.529C17.0374 20.3878 17.6582 17.4488 18.6687 15.3606C20.0797 12.4376 23.0145 10.3891 27.8467 10.2804C29.2899 10.2486 25.1564 11.4968 27.0243 12.2627L25.7047 24.9909C26.21 30.9535 26.6722 31.1364 24.6861 36.7943Z",
    fill: "#361D07"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.5694 36.4474C29.7508 35.4218 27.5819 33.1507 25.1121 28.0653C22.4326 27.045 21.1426 25.985 20.5647 24.6069C19.1995 21.3341 20.2046 17.1788 22.309 14.5129C24.1526 12.1808 26.6655 11.0201 29.8046 10.9088C35.9053 10.6888 38.9261 13.8901 40.5171 18.7371C40.8235 19.6725 40.7563 21.8244 40.6865 22.8526C40.5709 24.5698 41.2401 23.955 41.5519 25.6166C41.6862 26.3454 41.7615 29.0219 41.3852 32.0298C41.1702 33.7708 41.4632 35.4457 40.6838 35.8962C39.8963 36.3467 38.2247 36.9165 35.5694 36.4474Z",
    fill: "#F1B287"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.5694 36.4474C29.7374 35.4219 27.5819 33.1508 25.1121 28.0653C22.4326 27.045 21.1426 25.985 20.5647 24.607C19.1995 21.3342 20.2046 17.1789 22.309 14.5129C24.1526 12.1809 26.6655 11.0201 29.8046 10.9088C33.6289 10.771 37.0986 12.7082 38.8106 15.0959C38.2784 18.602 34.1208 22.9348 32.3255 24.2519C31.1913 25.084 30.85 25.3941 30.8581 26.356C30.8742 28.3754 33.1801 28.015 33.4247 28.9213C33.6746 29.8514 31.315 30.4822 32.3819 32.907C32.6829 33.5854 34.9297 35.8538 35.9295 36.5057C35.8086 36.4951 35.6903 36.4686 35.5694 36.4474Z",
    fill: "#E8A476"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 9,
    width: 21,
    height: 22
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8567 9.97833H38.9037V30.2683H18.8567V9.97833Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.9038 14.1907C34.5607 25.2123 25.1273 27.3244 25.2241 29.6882C25.2994 31.5168 21.475 28.5858 20.4859 26.9984C17.7849 22.6444 18.473 16.5254 22.3215 12.8259C27.1565 8.17509 36.0469 9.64057 38.9038 14.1907Z",
    fill: "#361D07"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.7787 33.06C20.2128 30.3728 17.0871 25.6742 17.2995 20.61C17.3183 20.7186 17.3371 20.8273 17.3613 20.9359C17.7187 19.285 18.2804 16.9662 19.85 15.975C18.8367 17.5253 17.8665 20.8034 18.4309 23.2415C18.5546 20.7027 19.2506 19.5341 20.7153 17.104C19.9494 19.5447 19.7693 20.6126 19.6995 23.3925C20.0703 21.5137 21.5189 18.5747 22.5939 17.8274C21.4679 19.3539 20.6401 22.1046 21.4007 25.0965C21.4705 22.7062 22.8197 19.3592 24.5021 18.3813C23.7335 19.4758 22.7848 22.0463 23.0535 23.5436C23.9028 21.5375 23.8759 21.1373 25.6712 19.1313C24.8703 20.7001 24.6311 22.0675 24.451 23.6682C25.1901 22.2981 25.7572 21.0446 26.7623 19.5076C26.3941 20.5411 25.5126 23.9676 25.7223 24.9958C26.0018 24.3492 28.8721 21.5349 30.1272 20.4298C28.9769 22.5604 27.66 24.8368 26.3726 25.9074C26.2195 26.2732 31.565 23.472 37.2653 16.9609C34.5885 22.2663 29.9659 24.5082 25.9776 28.2024L26.163 30.3569C26.2087 31.0592 26.0851 32.4398 25.7787 33.06Z",
    fill: "#241304"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.8721 24.5977C21.464 24.0571 21.7301 26.7045 22.2595 28.2733C22.625 29.3492 23.5415 29.1743 23.9661 30.0091C24.4768 31.0055 25.3448 31.403 26.0409 31.3129C27.4492 31.1301 26.3554 29.1478 26.1 28.3422C26.1215 26.9748 25.3986 24.9395 23.8721 24.5977Z",
    fill: "#E8A476"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.2108 27.6265C24.5954 26.5903 24.2299 25.2149 22.6711 25.5462C24.0605 25.5144 24.4959 26.7148 25.2108 27.6265Z",
    fill: "#DB9669"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.093 21.6936C16.3646 24.977 18.0847 33.1233 24.9809 38.0603C25.4324 37.5012 26.1043 34.0614 25.927 32.6569C19.2269 27.8338 20.8958 29.9326 17.093 21.6936Z",
    fill: "#241304"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.4893 14.6261C37.8039 11.6103 32.8293 9.45844 27.4515 10.2959C24.9359 10.4734 21.3722 11.5228 19.8457 13.8257C22.1489 12.0767 24.2479 11.3055 27.2445 10.8577C25.5353 11.3108 21.8452 12.8532 20.4961 15.6278C22.3451 13.3514 24.9225 11.9389 27.5294 11.5387C24.8472 12.6597 24.2506 13.4733 22.7724 15.429C24.5731 13.9317 26.4356 12.5723 28.6071 11.9601C26.6721 13.0705 25.9545 13.8734 24.8849 15.9908C27.0591 13.9317 27.1317 13.203 30.0907 12.3815C29.1446 13.1606 27.0537 15.0501 26.1077 16.7514C27.9218 15.3098 29.5505 14.1782 31.5339 13.1023C30.346 14.2921 28.8947 15.8848 28.2228 17.1118C29.7628 15.8292 30.9991 14.6393 33.3856 13.5448C31.3592 15.3946 29.9482 16.7752 28.548 19.1179C30.2035 17.5438 31.6279 16.118 34.2187 14.3266C32.9663 16.1366 32.0768 17.1834 30.8055 18.996C32.5256 17.8459 34.8127 15.6331 36.3527 14.0245C35.2588 15.6145 31.9612 20.1196 30.5798 21.6434C32.23 20.3979 36.1645 16.1101 37.2879 14.6261C36.8875 16.33 35.6351 18.1771 34.1784 19.6983C36.014 18.4713 37.3524 16.603 38.4893 14.6261Z",
    fill: "#4A2B12"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3563 48.471C9.11263 53.3603 8.71488 69.5866 8.01611 80.0225C9.53458 89.2527 10.6741 96.7471 12.894 105.845C14.7216 107.549 18.9518 107.072 19.9327 104.938C18.898 96.9591 18.6051 87.88 16.369 79.7204C17.6698 74.9874 20.094 62.715 20.0187 57.6534C19.9515 53.3762 18.9088 49.0619 15.9121 47.9569C14.9393 47.5965 14.0147 47.7104 13.3563 48.471Z",
    fill: "#99AAE0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3563 48.471C9.11263 53.3603 8.71488 69.5866 8.01611 80.0225C9.53458 89.2527 10.701 96.7471 12.9182 105.845C13.8239 106.69 15.3316 106.99 16.7104 106.833C15.4123 98.2682 13.0445 88.2112 11.4642 79.6012C13.3563 69.2819 12.8026 57.5951 16.8232 48.4286C16.5437 48.2378 16.2373 48.0761 15.9121 47.9569C14.9393 47.5965 14.0147 47.7104 13.3563 48.471Z",
    fill: "#99AAE0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFemaleIcon);
export default __webpack_public_path__ + "static/media/femaleIcon.ca16bbe73d904f80a9ff865a0cf04e55.svg";
export { ForwardRef as ReactComponent };